import { FC } from "react";
import moment, { Moment } from "moment";
import { Box, TextField, Tooltip } from "@mui/material";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import ViewEditTextField from "../view-edit-text-field";

interface ViewEditTimeProps {
  props: {
    id: string;
    label: string;
    tooltip?: string;
    value?: string;
    isEdit: boolean;
    format?: string;
    handleInputChange?: (newValue: string, field: string) => void;
  };
}

const ViewEditTime: FC<ViewEditTimeProps> = ({ props }) => {
  const timeStorageFormat = "HH:mm";
  const timeDisplayFormat = "hh:mm a";

  const createMomentFromTime = (time: string | undefined): moment.Moment | null => {
    return time ? moment(time, timeStorageFormat, true) : null;
  };

  const handleOnChange = (newValue: any) => {
    if (props.handleInputChange) {
      const time = (newValue as unknown as Moment)?.format(timeStorageFormat) ?? "";
      props.handleInputChange(time, props.id);
    }
  };

  return (
    <>
      {props.isEdit ? (
        <Box m={1} className="view-edit-box">
          <Tooltip title={props.tooltip ?? ""}>
            {/* Use a react fragment because Tooltip must be given a child that supports refs, and LocalizationProvider does not. */}
            <>
              <LocalizationProvider dateAdapter={AdapterMoment}>
                <TimePicker
                  label={props.label}
                  value={createMomentFromTime(props.value)}
                  onChange={(newValue) => handleOnChange(newValue)}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="dense"
                      fullWidth
                      InputLabelProps={{
                        shrink: props.isEdit || (props.value ? true : false),
                      }}
                    />
                  )}
                />
              </LocalizationProvider>
            </>
          </Tooltip>
        </Box>
      ) : (
        <ViewEditTextField
          props={{
            id: props.id,
            label: props.label,
            initialValue: createMomentFromTime(props.value)?.format(props.format || timeDisplayFormat) ?? "",
            isEdit: props.isEdit,
            characterLimit: 100,
            handleInputChange: (newValue) => handleOnChange(newValue),
          }}
        />
      )}
    </>
  );
};

export default ViewEditTime;
